/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetFolderFileDownloadUrlQueryResponse, ArtifactsControllerGetFolderFileDownloadUrlPathParams, ArtifactsControllerGetFolderFileDownloadUrlQueryParams, ArtifactsControllerGetFolderFileDownloadUrl404 } from "../../models/documentArtifactsController/ArtifactsControllerGetFolderFileDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerGetFolderFileDownloadUrl } from "../../clients/document-artifactsService/artifactsControllerGetFolderFileDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerGetFolderFileDownloadUrlQueryKey = (documentId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["artifactId"], fileName: ArtifactsControllerGetFolderFileDownloadUrlPathParams["fileName"], params: ArtifactsControllerGetFolderFileDownloadUrlQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/files/:fileName/download-url',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId,
    fileName: fileName
  }
}, ...(params ? [params] : [])] as const;
export type ArtifactsControllerGetFolderFileDownloadUrlQueryKey = ReturnType<typeof artifactsControllerGetFolderFileDownloadUrlQueryKey>;
export function artifactsControllerGetFolderFileDownloadUrlQueryOptions(documentId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["artifactId"], fileName: ArtifactsControllerGetFolderFileDownloadUrlPathParams["fileName"], params?: ArtifactsControllerGetFolderFileDownloadUrlQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerGetFolderFileDownloadUrlQueryKey(documentId, renditionId, artifactId, fileName, params);
  return queryOptions<ArtifactsControllerGetFolderFileDownloadUrlQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFolderFileDownloadUrl404>, ArtifactsControllerGetFolderFileDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId && fileName),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerGetFolderFileDownloadUrl(documentId, renditionId, artifactId, fileName, params, config);
    }
  });
}

/**
 * @description Generates a presigned URL for downloading a specific file within a FOLDER type artifact
 * @summary Get presigned download URL for a file within a folder artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/files/:fileName/download-url}
 */
export function useArtifactsControllerGetFolderFileDownloadUrl<TData = ArtifactsControllerGetFolderFileDownloadUrlQueryResponse, TQueryData = ArtifactsControllerGetFolderFileDownloadUrlQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerGetFolderFileDownloadUrlQueryKey>(documentId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetFolderFileDownloadUrlPathParams["artifactId"], fileName: ArtifactsControllerGetFolderFileDownloadUrlPathParams["fileName"], params?: ArtifactsControllerGetFolderFileDownloadUrlQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerGetFolderFileDownloadUrlQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFolderFileDownloadUrl404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerGetFolderFileDownloadUrlQueryKey(documentId, renditionId, artifactId, fileName, params);
  const query = useQuery({
    ...artifactsControllerGetFolderFileDownloadUrlQueryOptions(documentId, renditionId, artifactId, fileName, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerGetFolderFileDownloadUrl404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}